var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2824 0C18.58 0 17.8895 0.275344 17.3597 0.804005L8.2639 9.8665L8.06189 10.0684L8.0068 10.3557L7.37323 13.568L7.08859 14.9154L8.4356 14.6309L11.6493 13.9976L11.9367 13.9425L12.1387 13.7406L21.2052 4.64873C21.5849 4.26784 21.8433 3.78315 21.948 3.25571C22.0526 2.72827 21.9987 2.18167 21.7931 1.68478C21.5875 1.18789 21.2394 0.762938 20.7926 0.463454C20.3458 0.163969 19.8204 0.00335145 19.2824 0.00183549V0ZM19.2824 1.78056C19.4982 1.78056 19.7085 1.8907 19.9142 2.09537C20.3237 2.50471 20.3237 2.9471 19.9142 3.35736L11.0185 12.2473L9.43921 12.563L9.75599 10.9844L18.6516 2.09262C18.8564 1.88794 19.0667 1.77781 19.2824 1.77781V1.78056ZM0 3.64372V22H18.3642V9.89587L16.5278 11.7315V20.1644H1.83642V5.47935H10.2729L12.1094 3.64372H0Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRca);
export default __webpack_public_path__ + "static/media/rca.f590c8eace8e34f35b6ba27631d4fb72.svg";
export { ForwardRef as ReactComponent };